import {getId} from 'apis/model/base'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback} from 'react'
import {NullAsDefault} from 'views/Shared'
import {API_ROOT_URL} from "../../../../../envs/_current/config";
import {getTokenKey} from "../../../../../helpers/localStorage";
import DebounceSelect from "../../../../../components/LookupField/DebounceSelect";
import classNames from "classnames";
import {renderIf} from "../../../../Shared";


const renderOptionItem = (item) => {
    return (
        {
            id: item?.id,
            value: getId(item),
            label: (
                <span className="flex flex-col leading-tight">
                  <div className="flex gap-2 items-center justify-start">
                    <div className="font-medium text-sm text-color-000">
                      {getTitle(item)}
                    </div>
                  </div>
                </span>
            ),
        }
    )
}

export const fetchCourses =
    ({owner_id, owner_type}) =>
        async (type, keyword) => {
            const response = await fetch(
                API_ROOT_URL +
                `/courses/course/${owner_type}/${owner_id}/gets?keyword=${keyword}`,
                {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${getTokenKey()}`,
                        'Content-Type': 'application/json',
                    },
                }
            )
            const body = await response.json()
            return Array.from(_.get(body, 'data') || []).map(renderOptionItem)
        }

export const fetchSubjectsInCourse =
    ({course_id}) =>
        async (type, keyword) => {
            const response = await fetch(
                API_ROOT_URL +
                `/courses/course/${course_id}/course-subject/gets?keyword=${keyword}`,
                {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${getTokenKey()}`,
                        'Content-Type': 'application/json',
                    },
                }
            )
            const body = await response.json()
            return Array.from(_.get(body, 'data') || []).map((e) => renderOptionItem(e.subject))
        }

export const fetchClassesInCourse =
    ({course_id}) =>
        async (type, keyword) => {
            const response = await fetch(
                API_ROOT_URL +
                `/courses/course/${course_id}/course-class/gets?keyword=${keyword}`,
                {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${getTokenKey()}`,
                        'Content-Type': 'application/json',
                    },
                }
            )
            const body = await response.json()
            return Array.from(_.get(body, 'data') || []).map(renderOptionItem)
        }


export const CourseClassAttendanceReportFilter = ({
                                                      owner_id,
                                                      owner_type,
                                                      className = "",
                                                      value: filter = {
                                                          course_id: undefined,
                                                          subject_id: undefined,
                                                          course_class_id: undefined,
                                                      },
                                                      onChange: setValues = NullAsDefault,
                                                  }) => {
    const t = useTranslate()

    const handleChange = useCallback(
        (name, value) => {
            const params = {
                ...filter,
                [name]: value,
            }
            setValues(params)
            return params
        },
        [filter]
    )

    return (
        <div className="flex flex-col items-center gap-2 mt-2">
            <div className="flex items-center gap-2 w-full">
                <div className="text-sm text-color-400 italic whitespace-no-wrap">
                    {`${t('course')} : `}
                </div>
                <DebounceSelect
                    name={"course_id"}
                    type={"course_id"}
                    value={filter.course_id}
                    className={classNames('w-full', className)}
                    notFoundContent={undefined}
                    onChange={(value, option) => {
                        if (value !== filter.course_id) {
                            const next = handleChange("course_id", value)
                            setValues({
                                ...(next ?? {}),
                                subject_id: undefined,
                                course_class_id: undefined
                            })
                        }
                    }}
                    fetchOptions={fetchCourses({
                        owner_id,
                        owner_type,
                    })}
                />
            </div>
            {renderIf(
                filter.course_id,
                <div className="flex items-center gap-2 w-full">
                    <div className="text-sm text-color-400 italic whitespace-no-wrap">
                        {`${t('subjects')} : `}
                    </div>
                    <DebounceSelect
                        name={"subject_id"}
                        type={"subject_id"}
                        value={filter.subject_id}
                        className={classNames('w-full', className)}
                        notFoundContent={undefined}
                        onChange={(value, option) => {
                            if (value !== filter.subject_id) {
                                const next = handleChange("subject_id", value)
                                setValues({
                                    ...filter,
                                    ...(next ?? {}),
                                })
                            }
                        }}
                        fetchOptions={fetchSubjectsInCourse({
                            course_id: filter.course_id
                        })}
                    />
                </div>
            )}
            {renderIf(
                filter.course_id,
                <div className="flex items-center gap-2 w-full">
                    <div className="text-sm text-color-400 italic whitespace-no-wrap">
                        {`${t('classes')} : `}
                    </div>
                    <DebounceSelect
                        name={"course_class_id"}
                        type={"course_class_id"}
                        value={filter.course_class_id}
                        className={classNames('w-full', className)}
                        notFoundContent={undefined}
                        onChange={(value, option) => {
                            if (value !== filter.course_class_id) {
                                const next = handleChange("course_class_id", value)
                                setValues({
                                    ...filter,
                                    ...(next ?? {}),
                                })
                            }
                        }}
                        fetchOptions={fetchClassesInCourse({
                            course_id: filter.course_id
                        })}
                    />
                </div>
            )}
        </div>
    )
}

export default CourseClassAttendanceReportFilter
